import React, { useEffect, useState } from 'react';
import { useApi } from "../../context/ApiProvider";
import ActivityIndicator from '../Helpers/ActivityIndicator';
import Card from '../Helpers/Card';
import { Formik, Form, Field } from 'formik';
import moment from 'moment';
import { Link } from 'react-router-dom';

function Partners() {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const Api = useApi();

    useEffect(() => {
        refresh()
      }, [])
    
      function refresh () {
        fetchPartners();
      };

      function fetchPartners() {
        Api.get("/rolf/partners")
        .then(response => {
          setPartners(response);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
            setLoading(false);
        })
      }

    if(loading) {
        return <div>Loading...  <ActivityIndicator color="black" /> </div>
    }


  return (
    <div className="grid-container">
      <section className="grow">
        <h4>Partners</h4>
        <div className="flex wrap">
          {partners && partners.map((partner, index) => {
            return (<Card key={partner.ID} className="small"><Link to={`/rolf/partners/${partner.ID}`}>{partner.name}</Link></Card>)
          })}
        </div>
        </section>
        <section>
            <h4>Add new partner</h4>
            <Card>
                <Formik initialValues={{ name: '', startDate: moment().format("YYYY-MM-DD"), partnerData: [] }} onSubmit={(values, { setSubmitting, resetForm}) => {
                        if(!values.name) {
                            window.alert('Name is required');
                            setSubmitting(false);
                            return;
                        }

                        values.startDate = moment(values.startDate).unix();

                        Api.post("/rolf/partners", values)
                        .then(response => {
                            resetForm();
                            refresh();
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .finally(() => {
                            setSubmitting(false);
                        })
                    }}>
                    {({ isSubmitting }) => (
                    <Form>
                        <label htmlFor="name">Name</label>
                        <Field type="text" name="name" id="name" className="formControl" />
                        <label htmlFor="startDate">Start date</label>
                        <Field type="date" name="startDate" id="startdate" className="formControl" />
                        <button type="submit" disabled={isSubmitting}>Add</button>
                    </Form>)}

                </Formik>
            </Card>

        </section>
    </div>
  )
}

export default Partners